/* ============================================================
   jh-header.js — Custom Header für Inner Sparkle
   Phase 1: Drawer-Toggle, Akkordeon, Sticky-Behavior, USP-Rotation
   ============================================================ */

(function () {
  'use strict';

  /* ===== Drawer Toggle ===== */

  function initDrawer() {
    var toggleBtns = document.querySelectorAll('[data-jh-drawer-toggle]');
    var closeBtns = document.querySelectorAll('[data-jh-drawer-close]');
    var drawer = document.querySelector('[data-jh-drawer]');

    if (!drawer) return;

    // Drawer und Overlay als direkte body-Kinder verschieben damit kein
    // Parent-Stacking-Context (z.B. transformed Header-Section) im Weg liegt.
    var jhOverlayInit = drawer.querySelector('overlay-element');
    if (jhOverlayInit && jhOverlayInit.parentNode !== document.body) {
      document.body.appendChild(jhOverlayInit);
    }
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    // Concepts Hamburger-Button(s) abfangen und an unseren Drawer hängen
    // Wir suchen Concepts .menu-drawer-button (rendert via header-icons snippet)
    var conceptHamburgers = document.querySelectorAll('.header-section .menu-drawer-button');
    conceptHamburgers.forEach(function (btn) {
      // aria-controls von MenuDrawer auf JhDrawer umbiegen
      btn.setAttribute('aria-controls', drawer.id);
      // als Toggle markieren damit der Listener unten greift
      btn.setAttribute('data-jh-drawer-toggle', '');
    });

    // Re-query nach dem Hook
    toggleBtns = document.querySelectorAll('[data-jh-drawer-toggle]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jh-drawer-open');
      if (drawer.classList.contains('jh-drawer--slideup-sheet')) {
        document.body.classList.add('jh-drawer-sheet-open');
      }

      // Concept-Pattern: overlay-element via aria-expanded triggern
      var jhOverlay = document.querySelector('overlay-element[aria-controls="' + drawer.id + '"]');
      if (jhOverlay) {
        jhOverlay.setAttribute('aria-expanded', 'true');
        if (!jhOverlay.__jhBound) {
          jhOverlay.addEventListener('click', function () {
            if (drawer.classList.contains('is-open')) closeDrawer();
          });
          jhOverlay.__jhBound = true;
        }
      }

      toggleBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      // Fokus auf Close-Button für Accessibility
      setTimeout(function () {
        var closeBtn = drawer.querySelector('[data-jh-drawer-close]');
        if (closeBtn) closeBtn.focus();
      }, 100);
    }

    function closeDrawer() {
      // Closing-Klasse triggert die Schließ-Animation
      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jh-drawer-open');

      // Concept-Pattern: overlay-element via aria-expanded zurücksetzen
      var jhOverlayClose = document.querySelector('overlay-element[aria-controls="' + drawer.id + '"]');
      if (jhOverlayClose) {
        jhOverlayClose.setAttribute('aria-expanded', 'false');
      }

      // Closing-Klasse nach Animation wieder entfernen
      window.setTimeout(function () {
        drawer.classList.remove('is-closing');
        document.body.classList.remove('jh-drawer-sheet-open');
      }, 280);

      // Reset Such-State: Input leeren, Panel verstecken, Drawer-Body-Klasse entfernen
      var drawerSearchInputs = drawer.querySelectorAll('[data-jh-search] [data-jh-search-input]');
      drawerSearchInputs.forEach(function (inp) {
        inp.value = '';
        // dispatch input event so JS state resets
        inp.dispatchEvent(new Event('input', { bubbles: true }));
      });
      var drawerBody = drawer.querySelector('.jh-drawer__body');
      if (drawerBody) drawerBody.classList.remove('has-active-search');

      toggleBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }, true); // capture phase, damit wir VOR Concepts Listener feuern
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    // ESC schließt Drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Swipe-to-close (Touch, nur wenn aktiviert)
    if (drawer.hasAttribute('data-jh-swipe-close')) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTime = 0;
      var touchTracking = false;

      var animMode = drawer.getAttribute('data-jh-anim') || 'slide_left';
      var isVertical = (animMode === 'slide_up');
      var edgeZone = 30; // px vom inneren Drawer-Rand → immer Swipe-Close

      drawer.addEventListener('touchstart', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (e.touches.length !== 1) return;

        var startX = e.touches[0].clientX;
        var startY = e.touches[0].clientY;
        var rect = drawer.getBoundingClientRect();

        // Edge-Zone: rechter Rand bei slide_left, oberer Rand bei slide_up
        var isEdgeStart = false;
        if (isVertical) {
          var distFromTop = startY - rect.top;
          isEdgeStart = distFromTop <= edgeZone;
        } else {
          var distFromRightEdge = rect.right - startX;
          isEdgeStart = distFromRightEdge <= edgeZone;
        }

        if (isVertical && !isEdgeStart) {
          // Slide-Up: nur tracken wenn Drawer-Body ganz oben gescrollt ist
          var scrollableEl = drawer.querySelector('.jh-drawer__body, .jh-drawer__inner');
          if (scrollableEl && scrollableEl.scrollTop > 0) {
            return;
          }
        }

        if (!isEdgeStart) {
          // In scroll-baren Elementen kein Drawer-Swipe (außer am Edge)
          var t = e.target;
          while (t && t !== drawer) {
            if (t.classList && (
                t.classList.contains('jh-drawer__carousel-track') ||
                t.classList.contains('jh-drawer__carousel') ||
                t.classList.contains('jh-search__tabs') ||
                t.classList.contains('swiper') ||
                t.classList.contains('swiper-wrapper') ||
                t.hasAttribute('data-jh-no-swipe')
              )) {
              return;
            }
            t = t.parentElement;
          }
        }

        touchStartX = startX;
        touchStartY = startY;
        touchStartTime = Date.now();
        touchTracking = true;
      }, { passive: true });

      drawer.addEventListener('touchmove', function (e) {
        if (!touchTracking) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        if (isVertical) {
          // Slide-Up: Wisch primär horizontal → abbrechen (lass es scrollen)
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
            touchTracking = false;
            return;
          }
          // Nur nach unten interessant (dy positiv)
          if (dy > 0) {
            var translateY = Math.min(dy, drawer.offsetHeight);
            drawer.style.transform = 'translateY(' + translateY + 'px)';
            drawer.style.transition = 'none';
          }
        } else {
          // Slide-Left: Wisch primär vertikal → abbrechen
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
            touchTracking = false;
            return;
          }
          if (dx < 0) {
            var translateX = Math.max(dx, -drawer.offsetWidth);
            drawer.style.transform = 'translateX(' + translateX + 'px)';
            drawer.style.transition = 'none';
          }
        }
      }, { passive: true });

      drawer.addEventListener('touchend', function (e) {
        if (!touchTracking) return;
        touchTracking = false;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        var elapsed = Date.now() - touchStartTime;
        drawer.style.transform = '';
        drawer.style.transition = '';

        if (isVertical) {
          var height = drawer.offsetHeight;
          // Höherer Threshold (45%) damit kleine Bewegungen nicht versehentlich schließen
          if (dy > height * 0.45 || (elapsed < 250 && dy > 80)) {
            closeDrawer();
          }
        } else {
          var width = drawer.offsetWidth;
          if (dx < -width * 0.35 || (elapsed < 300 && dx < -50)) {
            closeDrawer();
          }
        }
      }, { passive: true });

      drawer.addEventListener('touchcancel', function () {
        touchTracking = false;
        drawer.style.transform = '';
        drawer.style.transition = '';
      });
    }

    // Beim Wechsel auf Desktop (≥990px) Drawer & Standalone-Search schließen
    var mediaQuery = window.matchMedia('(min-width: 990px)');
    function handleBreakpointChange(e) {
      if (e.matches) {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        }
        // Auch ein eventuell offenes Standalone-Search-Overlay schließen
        var openStandalone = document.querySelector('.jh-search--standalone.is-open');
        if (openStandalone) {
          openStandalone.classList.remove('is-open');
          openStandalone.setAttribute('inert', '');
          openStandalone.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('jh-search-open');
        }
      }
    }
    // Safari < 14 fallback
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleBreakpointChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleBreakpointChange);
    }
  }

  /* ===== Akkordeon ===== */

  function initAccordion() {
    var toggleBtns = document.querySelectorAll('[data-jh-accordion-toggle]');

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var controlsId = btn.getAttribute('aria-controls');
        var content = document.getElementById(controlsId);

        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');

        if (content) {
          if (expanded) {
            content.setAttribute('hidden', '');
          } else {
            content.removeAttribute('hidden');
          }
        }
      });
    });
  }

  /* ===== Sticky-Header Behavior ===== */

  function initStickyHeader() {
    var header = document.querySelector('.jh-header[data-sticky="on-scroll-up"]');
    if (!header) return;

    var lastScroll = 0;
    var threshold = 80;

    function onScroll() {
      var current = window.pageYOffset || document.documentElement.scrollTop;

      // Scrolled state
      if (current > 8) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      // Hide on scroll down, show on scroll up
      if (current > threshold) {
        if (current > lastScroll) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-hidden');
      }

      lastScroll = current;
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Also handle always-sticky
    var alwaysSticky = document.querySelector('.jh-header[data-sticky="always"]');
    if (alwaysSticky) {
      window.addEventListener('scroll', function () {
        if (window.pageYOffset > 8) {
          alwaysSticky.classList.add('is-scrolled');
        } else {
          alwaysSticky.classList.remove('is-scrolled');
        }
      }, { passive: true });
    }
  }

  /* ===== USP-Bar Auto-Rotate ===== */

  function initUspRotation() {
    var uspBars = document.querySelectorAll('.jh-usp-bar[data-jh-usp-mode="rotate"]');

    uspBars.forEach(function (bar) {
      var items = bar.querySelectorAll('.jh-usp-bar__item');
      if (items.length <= 1) return;

      var interval = parseInt(bar.getAttribute('data-jh-usp-interval'), 10) || 4000;
      var index = 0;

      setInterval(function () {
        items[index].removeAttribute('data-active');
        index = (index + 1) % items.length;
        items[index].setAttribute('data-active', '');
      }, interval);
    });
  }

  /* ===== Cart-Count Live Update (optional, listens to cart events) ===== */

  function initCartCount() {
    var cartCounts = document.querySelectorAll('[data-jh-cart-count]');
    if (!cartCounts.length) return;

    // Listen to Shopify cart update events if theme dispatches them
    document.addEventListener('cart:updated', function (e) {
      var newCount = (e.detail && e.detail.cart && e.detail.cart.item_count) || 0;
      cartCounts.forEach(function (el) {
        el.textContent = newCount;
        if (newCount === 0) {
          el.classList.add('is-empty');
        } else {
          el.classList.remove('is-empty');
        }
      });
    });

    // Fallback: poll cart.js after add-to-cart fetches
    document.addEventListener('click', function (e) {
      var target = e.target.closest('[name="add"], [data-cart-submit]');
      if (!target) return;
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cartCounts.forEach(function (el) {
              el.textContent = cart.item_count;
              if (cart.item_count === 0) {
                el.classList.add('is-empty');
              } else {
                el.classList.remove('is-empty');
              }
            });
          })
          .catch(function () { /* silent */ });
      }, 800);
    });
  }

  /* ===== Predictive Search ===== */

  function initPredictiveSearch() {
    var searches = document.querySelectorAll('[data-jh-search]');
    if (!searches.length) return;

    searches.forEach(function (root) {
      var input = root.querySelector('[data-jh-search-input]');
      var clearBtn = root.querySelector('[data-jh-search-clear]');
      var panel = root.querySelector('[data-jh-search-panel]');
      var loadingState = root.querySelector('[data-jh-search-loading]');
      var noResultsState = root.querySelector('[data-jh-search-no-results]');
      var tabs = root.querySelectorAll('[data-jh-search-tab]');
      var tabPanels = root.querySelectorAll('[data-jh-search-tab-content]');
      var showAllBtn = root.querySelector('[data-jh-search-show-all]');
      var form = root.querySelector('[data-jh-search-form]');
      var mode = root.dataset.mode;
      var resultLimit = parseInt(root.dataset.resultLimit, 10) || 6;
      var showAllLabel = root.dataset.showAllLabel || 'Alle Ergebnisse anzeigen';
      var showProductPrice = root.dataset.showProductPrice === 'true';
      var showProductImage = root.dataset.showProductImage === 'true';

      var currentQuery = '';
      var debounceTimer = null;

      if (!input) return;

      // Triggers (only standalone has external triggers)
      if (mode === 'standalone') {
        var standaloneTriggers = document.querySelectorAll('[data-jh-search-trigger="standalone"][aria-controls="' + root.id + '"]');
        standaloneTriggers.forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openStandalone();
          });
        });
      }

      function openStandalone() {
        root.classList.add('is-open');
        root.removeAttribute('inert');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('jh-search-open');
        setTimeout(function () { input.focus(); }, 100);
      }

      function closeStandalone() {
        root.classList.remove('is-open');
        root.setAttribute('inert', '');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('jh-search-open');
        input.value = '';
        hidePanel();
      }

      function showPanel() {
        if (panel) panel.hidden = false;
        root.classList.add('jh-search--active');
        if (mode === 'drawer') {
          var drawerBody = root.closest('.jh-drawer__body');
          if (drawerBody) drawerBody.classList.add('has-active-search');
        }
      }

      function hidePanel() {
        if (panel) panel.hidden = true;
        root.classList.remove('jh-search--active');
        tabPanels.forEach(function (p) { p.innerHTML = ''; });
        if (showAllBtn) showAllBtn.style.display = 'none';
        if (loadingState) loadingState.style.display = 'none';
        if (noResultsState) noResultsState.style.display = 'none';
        if (mode === 'drawer') {
          var drawerBody = root.closest('.jh-drawer__body');
          if (drawerBody) drawerBody.classList.remove('has-active-search');
        }
      }

      // X-Button: clear text → if already empty, close (standalone) or just blur (drawer)
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            input.focus();
            hidePanel();
          } else {
            if (mode === 'standalone') {
              closeStandalone();
            } else {
              input.blur();
              hidePanel();
            }
          }
        });
      }

      // ESC
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (mode === 'standalone' && root.classList.contains('is-open')) {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            hidePanel();
          } else {
            closeStandalone();
          }
        } else if (mode === 'drawer' && root.classList.contains('jh-search--active')) {
          if (input.value.length > 0) {
            input.value = '';
            clearBtn.style.display = 'none';
            hidePanel();
          } else {
            input.blur();
            hidePanel();
          }
        }
      });

      // Form submit
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!input.value.trim()) {
            e.preventDefault();
          }
        });
      }

      // Show-all button
      if (showAllBtn) {
        showAllBtn.addEventListener('click', function () {
          if (form && input.value.trim()) {
            form.submit();
          }
        });
      }

      // Tab switching
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var tabName = tab.dataset.jhSearchTab;
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          tabPanels.forEach(function (panel) {
            panel.hidden = panel.dataset.jhSearchTabContent !== tabName;
          });
        });
      });

      // Input listener
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.style.display = q.length > 0 ? 'flex' : 'none';

        clearTimeout(debounceTimer);

        if (q.length === 0) {
          hidePanel();
          return;
        }

        if (q.length < 2) {
          showPanel();
          if (loadingState) loadingState.style.display = 'block';
          if (noResultsState) noResultsState.style.display = 'none';
          tabPanels.forEach(function (p) { p.hidden = true; });
          return;
        }

        showPanel();
        if (loadingState) loadingState.style.display = 'block';
        if (noResultsState) noResultsState.style.display = 'none';

        debounceTimer = setTimeout(function () {
          fetchPredictiveResults(q);
        }, 220);
      });

      // Focus → show panel if there's already a query
      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2) {
          showPanel();
        }
      });

      function fetchPredictiveResults(q) {
        currentQuery = q;

        var resources = [];
        tabPanels.forEach(function (p) {
          resources.push(p.dataset.jhSearchTabContent);
        });
        if (!resources.length) return;

        // Map plural tab keys to Shopify's singular API types
        var typeMap = {
          'products': 'product',
          'articles': 'article',
          'collections': 'collection',
          'pages': 'page',
          'queries': 'query'
        };

        // One request per type so the limit applies per-type independently.
        var requests = resources.map(function (pluralType) {
          var apiType = typeMap[pluralType] || pluralType;
          var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                    '&resources[type]=' + apiType +
                    '&resources[limit]=' + resultLimit;
          return fetch(url)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var bucket = data.resources && data.resources.results ? data.resources.results : {};
              // Shopify uses plural keys in the response (products, articles, ...)
              return { pluralType: pluralType, items: bucket[pluralType] || [] };
            })
            .catch(function () {
              return { pluralType: pluralType, items: [] };
            });
        });

        Promise.all(requests).then(function (chunks) {
          if (q !== currentQuery) return;
          var merged = {};
          chunks.forEach(function (c) { merged[c.pluralType] = c.items; });
          renderResults(merged);
        });
      }

      function renderResults(results) {
        if (loadingState) loadingState.style.display = 'none';

        var anyResults = false;

        tabPanels.forEach(function (tp) {
          var type = tp.dataset.jhSearchTabContent;
          var items = results[type] || [];
          if (items.length > 0) anyResults = true;

          tp.innerHTML = '';

          if (items.length === 0) {
            var emptyMsg = document.createElement('li');
            emptyMsg.className = 'jh-search__tab-empty';
            emptyMsg.textContent = 'Keine Treffer in dieser Kategorie.';
            tp.appendChild(emptyMsg);
            return;
          }

          items.forEach(function (item) {
            tp.appendChild(buildResultItem(type, item));
          });
        });

        // Re-show active tab's panel
        var activeTab = root.querySelector('[data-jh-search-tab].is-active');
        if (activeTab) {
          var tabName = activeTab.dataset.jhSearchTab;
          tabPanels.forEach(function (p) {
            p.hidden = p.dataset.jhSearchTabContent !== tabName;
          });
        } else {
          // No tabs (only 1 panel)
          tabPanels.forEach(function (p) { p.hidden = false; });
        }

        if (anyResults) {
          if (noResultsState) noResultsState.style.display = 'none';
          if (showAllBtn) {
            showAllBtn.style.display = '';
            var labelSpan = showAllBtn.querySelector('[data-jh-search-show-all-label]');
            if (labelSpan) labelSpan.textContent = showAllLabel;
          }
        } else {
          if (noResultsState) noResultsState.style.display = 'block';
          if (showAllBtn) showAllBtn.style.display = 'none';
        }
      }

      function buildResultItem(type, item) {
        var li = document.createElement('li');
        li.className = 'jh-search__item jh-search__item--' + type;

        var a = document.createElement('a');
        a.href = item.url || '#';
        a.className = 'jh-search__item-link';

        if (type === 'products') {
          if (showProductImage && item.featured_image && item.featured_image.url) {
            var imgWrap = document.createElement('div');
            imgWrap.className = 'jh-search__item-image';
            var img = document.createElement('img');
            img.src = item.featured_image.url.replace(/(\.[^.]+)$/, '_120x120$1');
            img.alt = item.featured_image.alt || item.title || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            img.width = 60;
            img.height = 60;
            imgWrap.appendChild(img);
            a.appendChild(imgWrap);
          }

          var info = document.createElement('div');
          info.className = 'jh-search__item-info';

          var title = document.createElement('span');
          title.className = 'jh-search__item-title';
          title.textContent = item.title;
          info.appendChild(title);

          if (showProductPrice && item.price) {
            var priceWrap = document.createElement('div');
            priceWrap.className = 'jh-search__item-price';

            var price = document.createElement('span');
            price.className = 'jh-search__item-price-current';
            price.textContent = formatPrice(item.price);
            priceWrap.appendChild(price);

            if (item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price)) {
              var compare = document.createElement('span');
              compare.className = 'jh-search__item-price-compare';
              compare.textContent = formatPrice(item.compare_at_price);
              priceWrap.appendChild(compare);
            }

            info.appendChild(priceWrap);
          }

          a.appendChild(info);
        } else {
          // Articles, collections, pages: image (if present) + title
          var articleImage = item.image || item.featured_image;
          if (articleImage && (articleImage.url || typeof articleImage === 'string')) {
            var imgWrap2 = document.createElement('div');
            imgWrap2.className = 'jh-search__item-image';
            var img2 = document.createElement('img');
            var imgUrl = articleImage.url || articleImage;
            img2.src = imgUrl.replace(/(\.[^.]+)(\?.*)?$/, '_120x120$1$2');
            img2.alt = (articleImage.alt) || item.title || '';
            img2.loading = 'lazy';
            img2.decoding = 'async';
            img2.width = 60;
            img2.height = 60;
            imgWrap2.appendChild(img2);
            a.appendChild(imgWrap2);
          }

          var info2 = document.createElement('div');
          info2.className = 'jh-search__item-info';
          var title2 = document.createElement('span');
          title2.className = 'jh-search__item-title';
          title2.textContent = item.title || item.text || '';
          info2.appendChild(title2);
          a.appendChild(info2);
        }

        li.appendChild(a);
        return li;
      }

      function formatPrice(priceStr) {
        var num = parseFloat(priceStr);
        if (isNaN(num)) return priceStr;
        if (num > 1000 && num % 1 === 0) num = num / 100;
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(num);
      }
    });
  }

  /* ===== Init ===== */

  function initLangDropdown() {
    var wraps = document.querySelectorAll('[data-jh-lang-dropdown]');
    wraps.forEach(function (wrap) {
      var toggle = wrap.querySelector('[data-jh-lang-toggle]');
      var menu = wrap.querySelector('[data-jh-lang-menu]');
      if (!toggle || !menu) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          menu.setAttribute('hidden', '');
        } else {
          menu.removeAttribute('hidden');
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          toggle.setAttribute('aria-expanded', 'false');
          menu.setAttribute('hidden', '');
        }
      });
    });
  }

  function init() {
    initDrawer();
    initAccordion();
    initStickyHeader();
    initUspRotation();
    initCartCount();
    initPredictiveSearch();
    initLangDropdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.jh-header')) {
      init();
    }
  });
})();

/* ============================================================
   MEGA-MENU INSTANT HOVER (kein Concept-Delay)
   ============================================================ */
(function () {
  function initInstantHover() {
    var megas = document.querySelectorAll('details[is="details-mega"]');
    megas.forEach(function (d) {
      if (d.__jhInstantBound) return;
      d.__jhInstantBound = true;

      // Schließen anderer offener Mega-Menus beim Wechsel
      function closeOthers() {
        document.querySelectorAll('details[is="details-mega"][open]').forEach(function (other) {
          if (other !== d) other.removeAttribute('open');
        });
      }

      d.addEventListener('mouseenter', function () {
        closeOthers();
        d.setAttribute('open', '');
        // Concept's eigene visibility-Klasse direkt entfernen
        var container = d.querySelector('.mega-menu__container');
        if (container) container.classList.remove('invisible');
      });

      d.addEventListener('mouseleave', function () {
        d.removeAttribute('open');
        var container = d.querySelector('.mega-menu__container');
        if (container) container.classList.add('invisible');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstantHover);
  } else {
    initInstantHover();
  }
  document.addEventListener('shopify:section:load', initInstantHover);

  /* ===== Promo-Button Color-Force =====
     Concept's Header-CSS überschreibt Link-Backgrounds mit !important.
     CSS-Spezifität reicht nicht; JS pushed die Farben als inline-style mit
     !important direkt aufs Element — höchste mögliche Priorität.
     Hover-Farben werden bei mouseenter/leave gewechselt wenn gesetzt. */
  function applyPromoColors() {
    document.querySelectorAll('.jh-header__promo-btn').forEach(function (btn) {
      if (btn.dataset.jhPromoBound === '1') return;
      btn.dataset.jhPromoBound = '1';

      var bg = (btn.style.getPropertyValue('--jh-promo-bg') || '').trim() || '#7B4D32';
      var color = (btn.style.getPropertyValue('--jh-promo-color') || '').trim() || '#FBF7F6';
      var bgHover = (btn.style.getPropertyValue('--jh-promo-bg-hover') || '').trim();
      var colorHover = (btn.style.getPropertyValue('--jh-promo-color-hover') || '').trim();

      function setNormal() {
        btn.style.setProperty('background-color', bg, 'important');
        btn.style.setProperty('background-image', 'none', 'important');
        btn.style.setProperty('color', color, 'important');
        // Filter brightness als Default-Hover wenn keine expliziten Farben
        btn.style.removeProperty('filter');
      }

      function setHover() {
        if (bgHover) {
          btn.style.setProperty('background-color', bgHover, 'important');
        }
        if (colorHover) {
          btn.style.setProperty('color', colorHover, 'important');
        }
        if (bgHover || colorHover) {
          // Explizite Hover-Farben überschreiben filter brightness
          btn.style.setProperty('filter', 'none', 'important');
        }
      }

      setNormal();
      btn.addEventListener('mouseenter', setHover);
      btn.addEventListener('mouseleave', setNormal);
      btn.addEventListener('focus', setHover);
      btn.addEventListener('blur', setNormal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPromoColors);
  } else {
    applyPromoColors();
  }
  document.addEventListener('shopify:section:load', applyPromoColors);

  /* ===== Mega-Menu Animation Speed Force =====
     Concept setzt transition-duration mit höherer Spezifität — CSS reicht nicht.
     JS pushed transition-duration direkt aufs Element als inline-style mit !important.
     Greift auf Concept's Slide-Down (transform translateY) + meine Underline (background-size). */
  function applyMegaSpeed() {
    var header = document.querySelector('[data-jh-mega-speed]');
    if (!header) return;
    var megaNum = parseInt(header.dataset.jhMegaSpeed, 10);
    if (isNaN(megaNum)) megaNum = 180;
    var underlineNum = parseInt(header.dataset.jhUnderlineSpeed, 10);
    if (isNaN(underlineNum)) underlineNum = megaNum;
    var megaSpeed = megaNum + 'ms';
    var underlineSpeed = underlineNum + 'ms';

    document.querySelectorAll('details[is="details-mega"]').forEach(function (d) {
      var container = d.querySelector('.mega-menu__container');
      var summary = d.querySelector('summary');

      // Mega-Menu: opacity + transform
      if (container) {
        container.style.setProperty(
          'transition',
          'opacity ' + megaSpeed + ' ease 0s, transform ' + megaSpeed + ' ease 0s',
          'important'
        );
      }
      // Underline: background-size (eigene Speed)
      if (summary) {
        summary.style.setProperty(
          'transition',
          'background-size ' + underlineSpeed + ' ease 0s',
          'important'
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMegaSpeed);
  } else {
    applyMegaSpeed();
  }
  document.addEventListener('shopify:section:load', applyMegaSpeed);

  /* ===== Mega-Menu Top-Offset =====
     Concept positioniert das Mega-Menu absolute zum Trigger — der vertikal mittig im
     Header sitzt. Folge: obere Hälfte des Menüs verschwindet hinter dem Header.
     Fix: top auf "Header-Unterkante" relativ zum Trigger setzen. Nur top, nichts sonst. */
  function setMegaTop() {
    var header = document.querySelector('header[data-section-id], .shopify-section-header header, header.header');
    if (!header) return;
    var headerBottom = header.getBoundingClientRect().bottom;

    document.querySelectorAll('details[is="details-mega"]').forEach(function (details) {
      var menu = details.querySelector('.mega-menu');
      if (!menu) return;
      var detailsTop = details.getBoundingClientRect().top;
      var topOffset = headerBottom - detailsTop;
      if (topOffset > 0) {
        menu.style.setProperty('top', topOffset + 'px', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setMegaTop);
  } else {
    setMegaTop();
  }
  window.addEventListener('resize', setMegaTop);
  document.addEventListener('shopify:section:load', setMegaTop);

  // Bei jedem Öffnen re-positionieren (Concept's JS überschreibt sonst)
  document.querySelectorAll('details[is="details-mega"]').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        requestAnimationFrame(setMegaTop);
        setTimeout(setMegaTop, 50);
      }
    });
  });
})();